import React, { useContext } from 'react';
import { Badge, Dropdown } from '@bynder/design-system';

import { InfoContext } from '../../context';
import { useUserMenuItems } from './useUserMenuItems';
import { OutOfOfficeModal } from '../OutOfOffice/OutOfOfficeModal';
import { navigateTo } from '../../helpers/windowLocation';

/*
 * bynder-platform/bynder/views/navigation/includes/menu.cfm: 71
 */
export function UserMenu() {
	const { general } = useContext(InfoContext);
	const menuItems = useUserMenuItems();

	const avatarStyle = {
		width: 22,
		height: 50,
		display: 'flex',
		backgroundImage: general.userPictureUrl ? `url(${general.userPictureUrl})` : undefined,
	};

	const anchorStyles = {
		display: 'flex',
		alignItems: 'center',
		gap: '6px',
	};

	return (
		<>
			<OutOfOfficeModal />
			<Dropdown
				trigger={({ isOpen, ...triggerProps }) => (
					<li className={`touch-block ${isOpen ? 'hover' : ''}`} {...triggerProps}>
						<a
							href="#"
							title={general.userName}
							className="admin-dropdown profile"
							style={anchorStyles}
						>
							<div className="avatar" style={avatarStyle} />
							{general.userName}
						</a>
					</li>
				)}
				minWidth="240px"
			>
				{menuItems.map((item) => {
					if (!item.isVisible) {
						return null;
					}

					if (item.Component) {
						const Component = item.Component;

						return <Component key={item.key} />;
					}

					const Icon = item.icon;

					return (
						<Dropdown.Item
							onClick={() => navigateTo(item.href)}
							icon={Icon ? <Icon /> : undefined}
							badge={
								item.badgeLabel ? (
									<Badge isPillShaped>{item.badgeLabel}</Badge>
								) : undefined
							}
							key={item.key}
						>
							{item.label}
						</Dropdown.Item>
					);
				})}
			</Dropdown>
		</>
	);
}
